const types = {
    EVENT: 'gameEvent',
    SET_HISTORY_FILTER: 'setHistoryFilter',
    GET_HISTORY_LIST: 'getHistoryList',
    SET_HISTORY_LIST: 'setHistoryList',
    SET_HISTORY_SELECTED_ROOM_ID: 'setHistorySelectedRoomId',
    GET_HISTORY_SELECTED_ROOM_ACTIONS: 'getHistorySelectedRoomActions',
    SET_HISTORY_SELECTED_ROOM_ACTIONS: 'setHistorySelectedRoomActions',
};
export default types
